import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { PageHeader, Form, Card } from "antd";
import { ProjectOutlined } from "@ant-design/icons";
import { handleApiError, handleApiSuccess, MyBreadcrumb } from "utils";
import { ticketProjectCreateService } from "services/tickets";
import { TicketAccessGate } from "../_useTicketAccess";
import TicketProjectForm from "./form";
import TicketBusy, { TicketProgressBar } from "../_components/TicketAsync";
import "../_styles.css";

function CreateContent() {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    ticketProjectCreateService({
      ...values,
      color: values.color || "#6366f1",
    })
      .then((res) => {
        handleApiSuccess(res);
        const id = res.data.item?._id;
        history.push(id ? "/tickets/projects/board/" + id : "/tickets/projects");
      })
      .catch((err) => {
        setLoading(false);
        handleApiError(err);
      });
  };

  return (
    <div className="ticket-system">
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Tickets", path: "/tickets/dashboard" },
          { label: "Projects", path: "/tickets/projects" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader title="New Project" avatar={{ icon: <ProjectOutlined /> }} />
      <TicketProgressBar active={loading} />
      <Card>
        <TicketBusy spinning={loading} tip="Creating project…">
          <TicketProjectForm form={form} onFinish={onFinish} loading={loading} submitLabel="Create Project" />
        </TicketBusy>
      </Card>
    </div>
  );
}

export default function TicketProjectCreate() {
  return (
    <TicketAccessGate>
      <CreateContent />
    </TicketAccessGate>
  );
}
